export const STEP_IDS = {
  PREREQUISITES: 'prerequisites',
  CONNECT: 'connect',
  IMPORT_PROGRESS: 'import-progress',
} as const;

export const FORM_IDS = {
  CONNECT: 'gerrit-connect-form',
  IMPORT_PROGRESS: 'gerrit-import-progress-form',
} as const;

export const FIELDS = {
  BASE_URL: 'baseUrl',
  USERNAME: 'username',
  TOKEN: 'token',
  API_PREFIX: 'apiPrefix',
} as const;

/**
 * Gerrit's authenticated REST path. Shown as the placeholder and sent only when
 * the user overrides it — an untouched field means "let the backend decide", so
 * the default lives in one place (the gateway) rather than being copied here.
 */
export const DEFAULT_GERRIT_API_PREFIX = '/a';

/**
 * Gerrit webhooks-plugin event types Qodo subscribes to for reviews. These are
 * literal plugin event identifiers (protocol values, not translatable copy).
 * ref-updated is intentionally excluded — it isn't needed for PR reviews.
 */
export const GERRIT_WEBHOOK_EVENTS = [
  'patchset-created',
  'comment-added',
  'wip-state-changed',
  'change-merged',
  'change-abandoned',
] as const;

/**
 * Read (ref) permissions the Qodo user needs, shown on the
 * prerequisites step. Patterns are literal Gerrit ref specs; purpose is i18n.
 */
export const GERRIT_REF_PERMISSIONS = [
  { pattern: 'refs/changes/*', purposeKey: 'ref-permissions.changes' },
  { pattern: 'refs/heads/*', purposeKey: 'ref-permissions.heads' },
  { pattern: 'refs/tags/*', purposeKey: 'ref-permissions.tags' },
] as const;

/**
 * Label permissions the Qodo user needs. Label + range are literal
 * Gerrit values; purpose is i18n.
 */
export const GERRIT_LABEL_PERMISSIONS = [
  {
    label: 'Code-Review',
    range: '-2..+2',
    purposeKey: 'label-permissions.code-review',
  },
  {
    label: 'Verified',
    range: '-1..+1',
    purposeKey: 'label-permissions.verified',
  },
] as const;

export const GENERAL_TRANSLATION_KEY = 'dialogs.gerrit-installation.general';
export const PREREQUISITES_TRANSLATION_KEY =
  'dialogs.gerrit-installation.prerequisites';
export const CONNECT_TRANSLATION_KEY = 'dialogs.gerrit-installation.connect';
export const IMPORT_PROGRESS_TRANSLATION_KEY =
  'dialogs.gerrit-installation.import';
export const STEPS_TRANSLATION_KEY = 'dialogs.gerrit-installation.steps';
